export default "__VITE_ASSET__BDUUPpwr__"